(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const target = event.target;

    if (!(target instanceof Element)) return;

    const button = target.closest(
      '.cart-page__recommendations [data-cart-complement-add]'
    );

    if (!(button instanceof HTMLButtonElement)) return;
    if (button.disabled) return;

    const variantId = Number(button.dataset.cartComplementAdd);

    if (!variantId) {
      console.warn('[cart-page-complements] Missing variant ID.');
      return;
    }

    const originalText = button.textContent?.trim() || 'Agregar';

    button.disabled = true;
    button.textContent = 'Agregando…';

    try {
      const root = window.Shopify?.routes?.root || '/';

      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1
            }
          ]
        })
      });

      const responseData = await response.json().catch(() => null);

      if (!response.ok) {
        throw new Error(
          responseData?.description ||
          responseData?.message ||
          'No se pudo agregar el producto.'
        );
      }

      window.location.reload();
    } catch (error) {
      console.error('[cart-page-complements]', error);

      button.disabled = false;
      button.textContent = 'Intenta de nuevo';

      window.setTimeout(() => {
        button.textContent = originalText;
      }, 2000);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
